export default "__VITE_ASSET__Cvjk8QHE__"